<template>
  <div :state="sendPickup">
    <b-overlay :show="chargingPickup" rounded="sm">
      <div class="pickup" :aria-hidden="chargingPickup ? 'true' : null">
        <h6 style="color: #4caf50">
          <b><i class="fa fa-map-marker-alt"></i> Pickup</b>
        </h6>

        <hr />

        <div class="pickup__cities">
          <b-form-input
            v-model="pickupAndDelivery.zip_from"
            onClick="this.select();"
            v-on:keyup.enter="addZipFrom"
            placeholder="Zip from"
            size="sm"
            list="zip_from"
            class="pickup__cities--input"
            autocomplete="off"
          ></b-form-input>

          <datalist id="zip_from">
            <option v-for="(zipf, index) in zip_from" v-bind:key="index">
              {{ zipf }}
            </option>
          </datalist>

          <b-form-input
            v-model="pickupAndDelivery.city_from"
            onClick="this.select();"
            v-on:keyup.enter="addCityFrom"
            placeholder="City from"
            size="sm"
            list="city_from"
            class="pickup__cities--input"
            autocomplete="off"
          ></b-form-input>

          <datalist id="city_from">
            <option v-for="(cityf, index) in city_from" v-bind:key="index">
              {{ cityf }}
            </option>
          </datalist>
        </div>

        <hr />
        <AccessorialsPickup
          v-model="pickupAndDelivery.accessorials"
          :tripNumber="tripNumber"
        />
      </div>
    </b-overlay>
  </div>
</template>

<script>
import AccessorialsPickup from "../LTL/AccessorialsPickup";
import { setZipCode, setCity } from "@/mixins/pickupAndDelivery/standardizers";
export default {
  name: "Pickup",
  components: {
    AccessorialsPickup
  },
  props: {
    tripNumber: Number,
    zipCodes: Array,
    cities: Array
  },
  data() {
    return {
      pickupAndDelivery: {
        zip_from: "",
        city_from: "",
        country_from: "",
        accessorials: null
      },
      zip_from: [],
      city_to: [],
      chargingPickup: false,
      haulInformation: null,
      allowed: true,
      tabprueba: null
    };
  },
  computed: {
    sendPickup() {
      return this.$emit("input", this.pickupAndDelivery);
    }
  },
  watch: {},
  async created() {
    this.haulInformation = this.$store.getters[
      "quotes/quote/showQuoteById"
    ].haul;
    this.zip_from = this.zipCodes;
    this.city_from = this.cities;
    if (
      this.$store.getters["quotes/quote/showQuoteById"].haul[
        this.tripNumber - 1
      ]
    ) {
      if (this.haulInformation[this.tripNumber - 1].zip_from != null) {
        this.pickupAndDelivery.zip_from = this.haulInformation[
          this.tripNumber - 1
        ].zip_from;
      }
      if (
        this.haulInformation[this.tripNumber - 1].city_from != null &&
        this.haulInformation[this.tripNumber - 1].city_from != "" &&
        this.haulInformation[this.tripNumber - 1].state_from != null &&
        this.haulInformation[this.tripNumber - 1].state_from != ""
      ) {
        this.pickupAndDelivery.city_from =
          this.haulInformation[this.tripNumber - 1].city_from +
          "," +
          this.haulInformation[this.tripNumber - 1].state_from;
      }
      let responseZip;
      if (
        this.pickupAndDelivery.zip_from != "" &&
        this.pickupAndDelivery.city_from == ""
      ) {
        this.chargingPickup = true;
        responseZip = await this.$store.dispatch(
          "standardize/standardizeZip",
          this.pickupAndDelivery.zip_from
        );
        this.chargingPickup = false;
        if (responseZip.status == 200) {
          if (responseZip.data[0][1] != "Not Acceptable") {
            this.pickupAndDelivery.city_from = responseZip.data[0][1];
            this.updatePickup();
            if (!this.city_from.includes(this.pickupAndDelivery.city_from)) {
              this.city_from.push(responseZip.data[0][1]);
            }
          }
        }
      }
      let responseCity;
      if (
        this.pickupAndDelivery.city_from != "" &&
        this.pickupAndDelivery.zip_from == ""
      ) {
        this.chargingPickup = true;
        responseCity = await this.$store.dispatch(
          "standardize/standardizeCity",
          this.pickupAndDelivery.city_from
        );
        this.chargingPickup = false;
        if (responseCity.status == 200) {
          if (responseCity.data[0][0] != "Not Acceptable") {
            this.pickupAndDelivery.zip_from = responseCity.data[0][0];
            this.updatePickup();
            if (!this.zip_from.includes(this.pickupAndDelivery.zip_from)) {
              this.zip_from.push(responseCity.data[0][0]);
            }
          }
        }
      }
    }
  },
  methods: {
    async confirmationAlert(first) {
      return await this.swal({
        title: "Warning!",
        text: `Do you want to keep ${first}?`,
        icon: "warning",
        buttons: ["Don't keep", "Keep"],
        dangerMode: false
      }).then(willDelete => {
        if (willDelete) {
          return false;
        } else {
          return true;
        }
      });
    },
    async addZipFrom() {
      if (this.pickupAndDelivery.zip_from.length == 1) {
        this.pickupAndDelivery.zip_from = "";
        this.swal({
          title: "Warning!",
          text: `zip code not allowed!`,
          icon: "warning",
          dangerMode: false
        });
      }
      if (
        this.pickupAndDelivery.zip_from != null &&
        this.pickupAndDelivery.zip_from != "" &&
        this.pickupAndDelivery.zip_from.length > 1
      ) {
        this.chargingPickup = true;
        let response = await setZipCode(
          this.pickupAndDelivery.zip_from.replaceAll(" ", ""),
          this.city_from,
          this.zip_from
        );
        if (response.exists) {
          this.pickupAndDelivery.zip_from = response.zip_code_response
            ? response.zip_code_response
            : this.pickupAndDelivery.zip_from;
          this.zip_from = response.arrayZipCode;
          this.city_from = response.city;
          this.pickupAndDelivery.city_from = response.city_selected;
          this.pickupAndDelivery.country_from = response?.country_response;
          this.updatePickup();
        } else {
          if (response.cancel) {
            this.pickupAndDelivery.zip_from = null;
          } else {
            this.zip_from = response.arrayZipCode;
            this.updatePickup();
          }
        }
      }
      this.chargingPickup = false;
      document.activeElement.blur();
    },
    async addCityFrom() {
      if (this.pickupAndDelivery.city_from.length == 1) {
        this.pickupAndDelivery.city_from = "";
        this.swal({
          title: "Warning!",
          text: `City not allowed!`,
          icon: "warning",
          dangerMode: false
        });
      }
      if (
        this.pickupAndDelivery.city_from != null &&
        this.pickupAndDelivery.city_from != "" &&
        this.pickupAndDelivery.city_from.length > 1
      ) {
        this.chargingPickup = true;
        let response = await setCity(
          this.pickupAndDelivery.city_from,
          this.zip_from,
          this.city_from
        );
        if (response.exists) {
          this.city_from = response.arrayCity;
          this.zip_from = response.zipCode;
          if (
            this.pickupAndDelivery.zip_from != null &&
            this.pickupAndDelivery.zip_from != ""
          ) {
            if (this.pickupAndDelivery.zip_from != response.zipCodeSelected) {
              let confirmation = await this.confirmationAlert(
                this.pickupAndDelivery.zip_from
              );
              if (confirmation) {
                this.pickupAndDelivery.zip_from = response.zipCodeSelected;
              }
            }
          } else {
            this.pickupAndDelivery.zip_from = response.zipCodeSelected;
          }
          this.pickupAndDelivery.city_from = response.citySelected;
          this.updatePickup();
        } else {
          if (response.cancel) {
            this.pickupAndDelivery.city_from = null;
          } else {
            this.city_from = response.arrayCity;
            this.updatePickup();
          }
        }
      }
      this.chargingPickup = false;
      document.activeElement.blur();
    },
    async updatePickup() {
      let info = {};
      info.haulId = this.haulInformation[this.tripNumber - 1].id;
      info.payload = {};
      if (this.pickupAndDelivery.zip_from != null) {
        info.payload.zip_from = this.pickupAndDelivery.zip_from;
      }
      if (
        this.pickupAndDelivery.city_from != null &&
        this.pickupAndDelivery.city_from.includes(",")
      ) {
        info.payload.city_from = this.pickupAndDelivery.city_from.split(",")[0];
        info.payload.state_from = this.pickupAndDelivery.city_from
          .split(",")[1]
          .replace(" ", "");
        info.payload.country_from = this.pickupAndDelivery.country_from;
      }
      await this.$store.dispatch("quotes/haul/updateHaul", info);
    }
  }
};
</script>

<style lang="scss" scoped>
.pickup {
  @include pickup-delivery;
}
</style>
